module.exports = __webpack_public_path__ + "img/tema-1-2.9a7eb3b2.svg";